import Serializer from 'umg-ember-backend/serializers/application';

export default class AssetFormatSerializer extends Serializer {
  attrs = {
    description: 'formatvDescription',
    height: 'formatvHeight',
    isCroppingFormat: 'useCropping',
    isDownloadFormat: 'flagIsDownladFormat',
    width: 'formatvWidth',
    name: 'formatvName',
    label: 'formatvLabel',
  };
}
